import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `GrupoUsuario/deleteGrupoUsuarioSeleccion`, method: 'POST', body: list, token: token})
}
